export default "__VITE_ASSET__BJxUs8qU__"